import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { StylesProvider, ThemeProvider } from '@material-ui/core/styles';
import { createTheme } from '../../theme';
/**
 *
 * API:
 *
 * - [StyledProvider API](https://components-extra.netlify.app/utils/styled-provider)
 */
const StyledProvider = ({ children, dark = false, theme, }) => {
    const finalTheme = useMemo(() => createTheme(dark, theme), [dark, theme]);
    return (React.createElement(StylesProvider, { injectFirst: true },
        React.createElement(ThemeProvider, { theme: finalTheme },
            React.createElement(StyledThemeProvider, { theme: finalTheme }, children))));
};
StyledProvider.propTypes = {
    children: PropTypes.node.isRequired,
    dark: PropTypes.bool,
    theme: PropTypes.object,
};
export default StyledProvider;
